import { useTranslation } from "react-i18next";

interface ValidationErrorProps {
  text: string;
  additionalUntranslatedText?: string;
  isAlwaysVisible?: boolean;
  className?: string;
}

export default function ValidationError(props: ValidationErrorProps) {
  const { t } = useTranslation();

  return (
    <div className={props.className ? props.className : "row ps-075-rem"}>
      <div
        className={
          "invalid-feedback custom-feedback" +
          (props.isAlwaysVisible ? " always-visible" : "")
        }
      >
        {t(props.text) +
          (props.additionalUntranslatedText
            ? props.additionalUntranslatedText
            : "")}
      </div>
    </div>
  );
}
